import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const PopupCustom = ({children, visible, width, title}) => visible && (
  <aside className="popup-custom depth-5" style={{width: width}}>
    <h3>{title}</h3>
    <div className="popup">
      {children}
    </div>
  </aside>
);

PopupCustom.defaultProps = {
  width: '350px',
};

PopupCustom.propTypes = {
  children: PropTypes.element,
  visible: PropTypes.bool.isRequired,
  width: PropTypes.string,
};

export default PopupCustom;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PopupCustom/index.js